import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
} from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { initialUserState, useReducer } from "./reducers/user/userReducer";
import { uiReducer } from "./reducers/ui/uiReducer";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { appReducer, initialAppState } from "./reducers/app/appReducer";
import { middleware } from "./middleware";
import { historyReducer } from "./reducers/history/historyReducer";
import { initialUiStateT } from "./reducers/types";
import { initialHistoryState } from "./reducers/history/historyTypes";

const rootReducer = combineReducers({
  user: useReducer,
  ui: uiReducer,
  app: appReducer,
  history: historyReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.REACT_APP_NODE_ENV_KEY !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(middleware),
});

const persistor = persistStore(store);

export { store, persistor };
// export type RootState = ReturnType<typeof rootReducer>;
// export type RootState = ReturnType<typeof store.getState>;
export interface RootState {
  user: initialUserState;
  ui: initialUiStateT;
  app: initialAppState;
  history: initialHistoryState;
}
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
